export default __webpack_public_path__ + "static/media/twitter.12993a04.png";